import { useState, useRef, useEffect } from 'react';

/**
 * Hook for TeacherShell to manage scroll-triggered title visibility.
 * Listens for scroll events on the <main> element and shows the title
 * when scrolled past 100px.
 *
 * Returns { scrollRef, visibleTitle } where:
 *   - scrollRef: attach to <main>
 *   - visibleTitle: the title string when visible, null when hidden
 */
export function useScrollTitle(titleText) {
  const scrollRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const visibleRef = useRef(false);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      const shouldBeVisible = el.scrollTop > 100;
      if (visibleRef.current !== shouldBeVisible) {
        visibleRef.current = shouldBeVisible;
        setVisible(shouldBeVisible);
      }
    };

    el.addEventListener('scroll', handleScroll, { passive: true });
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  const visibleTitle = visible && titleText ? titleText : null;

  return { scrollRef, visibleTitle };
}
